import React from 'react';
import cn from 'classnames';

import { Typography } from 'components/shared/Typography';

import styles from './ModulePreview.module.scss';

const ModulePreview = ({
  className,
  preview,
  order,
}: {
  className: any;
  preview: any;
  order: any;
}) =>
  preview ? (
    <img className={cn(styles.preview, className)} src={preview} />
  ) : (
    <div className={styles.outerСircle}>
      <div className={styles.innerСircle}>
        <Typography variant="body1" weight="semiBold" className={styles.order}>
          {order}
        </Typography>
      </div>
    </div>
  );

export default React.memo(ModulePreview) as any;
